(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[484],{

/***/ 6737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ _cmsGradientBlock; },
/* harmony export */   "u": function() { return /* binding */ GradientBlock; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);



var _cmsGradientBlock = {
  label: 'Blaues Rechteck',
  name: 'GradientBlock',
  widget: 'object',
  summary: '',
  fields: [{
    label: 'Höhe',
    hint: '(in Prozent der Seitenhöhe)',
    name: 'height',
    widget: 'string',
    value_type: 'int',
    min: 10,
    max: 100,
    step: 10,
    required: false
  }]
};
function GradientBlock(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '60' : _ref$height;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
    className: styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"].dynamic([["393245089", [height + 'vh']]]) + " " + "gradient-block",
    children: ["\xA0", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
      id: "393245089",
      dynamic: [height + 'vh'],
      children: [".gradient-block.__jsx-style-dynamic-selector{margin-top:10rem;margin-bottom:3rem;width:100%;height:".concat(height + 'vh', ";background-image:var(--bg-gradient);}")]
    })]
  });
}

/***/ }),

/***/ 3735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ _cmsImage; },
/* harmony export */   "w": function() { return /* binding */ BlueImage; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);



var _cmsImage = {
  label: 'Bild',
  name: 'BlueImage',
  widget: 'object',
  summary: 'Bild {{fields.alt}}',
  required: false,
  fields: [{
    label: 'Bild',
    name: 'imageSrc',
    widget: 'image'
  }, {
    label: 'Alternativtext',
    name: 'alt',
    hint: 'Wird statt dem Bild benutzt von z.B. Screenreadern oder Suchmaschinen.',
    widget: 'string'
  }, {
    label: 'Blaufilter',
    name: 'blue',
    widget: 'boolean',
    "default": true
  }, {
    label: 'Maximale Breite',
    hint: 'in Prozent',
    name: 'maxWidth',
    widget: 'select',
    options: ['50', '100'],
    "default": '50',
    required: false
  }]
};
var sizes = [1800, 900, 600, 300];
var formats = ['avif', 'webp', 'jpeg'];
function BlueImage(_ref) {
  var imageSrc = _ref.imageSrc,
      alt = _ref.alt,
      _ref$blue = _ref.blue,
      blue = _ref$blue === void 0 ? true : _ref$blue,
      className = _ref.className,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '50' : _ref$maxWidth,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("div", {
    style: {
      maxWidth: maxWidth + '%'
    },
    className: "jsx-3349978530" + " " + "img-wrapper ".concat(className !== null && className !== void 0 ? className : '', " ").concat(blue ? 'blue' : ''),
    children: [renderImage(), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
      id: "3349978530",
      children: [".img-wrapper img{max-width:100%;height:auto;}", ".img-wrapper.blue{background-color:var(--brand);}", ".img-wrapper.blue img{-webkit-filter:grayscale(100%);filter:grayscale(100%);mix-blend-mode:luminosity;opacity:0.7;}"]
    })]
  });

  function renderImage() {
    var fileName = imageSrc.substring(0, imageSrc.lastIndexOf('.'));
    var srcBase = '/' + fileName;
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("picture", {
      children: [formats.map(function (format) {
        var ext = format === 'jpeg' ? 'jpg' : format;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source", {
          type: 'image/' + format,
          srcSet: "".concat(srcBase, "-").concat(sizes[0], ".").concat(ext, " ").concat(sizes[0], "w, ").concat(srcBase, "-").concat(sizes[1], ".").concat(ext, " ").concat(sizes[1], "w, ").concat(srcBase, "-").concat(sizes[2], ".").concat(ext, " ").concat(sizes[2], "w, ").concat(srcBase, "-").concat(sizes[3], ".").concat(ext, " ").concat(sizes[3], "w"),
          sizes: "(max-width: ".concat(sizes[1], "px) 100vw, ").concat(sizes[1], "px")
        }, format);
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("img", {
        loading: "lazy",
        decoding: "async",
        width: width,
        height: height,
        src: "".concat(srcBase, "-").concat(sizes[0], ".jpg"),
        alt: alt !== null && alt !== void 0 ? alt : 'Bild'
      })]
    });
  }
}

/***/ }),

/***/ 3676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(5988);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(1720);
// EXTERNAL MODULE: ./src/components/blocks/gradient-block.tsx
var gradient_block = __webpack_require__(6737);
// EXTERNAL MODULE: ./src/components/footer/primary-nav.tsx
var primary_nav = __webpack_require__(4942);
// EXTERNAL MODULE: ./src/components/trans-link.tsx
var trans_link = __webpack_require__(2331);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(7997);
;// CONCATENATED MODULE: ./src/components/footer/secondary-nav.tsx

 // eslint-disable-next-line import/no-internal-modules




function SecondaryNav(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("nav", {
    className: "jsx-1874299308" + " " + "secondary",
    children: [data.map(renderLink), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
      id: "1874299308",
      children: [".secondary.jsx-1874299308{text-align:right;}"]
    })]
  });

  function renderLink(_ref2) {
    var title = _ref2.title,
        href = _ref2.href;
    return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)(compat_module.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(trans_link/* TransLink */.H, {
        href: href,
        className: className + ' ',
        children: title
      }), styles]
    }, href);
  }
}
var _styles$className = {
  styles: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
    id: "2225481763",
    children: ["a.jsx-2225481763{font-size:0.65rem !important;margin-left:0.4rem;border-bottom-width:0 !important;}", "a.jsx-2225481763:hover{border-bottom:1px solid black !important;}"]
  }),
  className: "jsx-2225481763"
},
    className = _styles$className.className,
    styles = _styles$className.styles;
;// CONCATENATED MODULE: ./src/components/footer/footer.tsx









function Footer(_ref) {
  var data = _ref.data;

  var _useState = (0,compat_module.useState)(false),
      showFullMail = _useState[0],
      setShowFullMail = _useState[1];

  var router = (0,next_router.useRouter)();
  var route = router.asPath.split('#')[0];
  var showContact = route === '/' || route === '/verlag';
  (0,compat_module.useEffect)(function () {
    if (!showContact) return;
    setShowFullMail(true);
  }, [showContact]);
  return /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("footer", {
    id: "contact",
    children: [showContact ? /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("div", {
      className: "jsx-3957130285" + " " + "serif",
      children: ["Wittendoerfer Verlagsgesellschaft", /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("br", {
        className: "jsx-3957130285"
      }), "Hohenzollernstra\xDFe 122", /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("br", {
        className: "jsx-3957130285"
      }), "80796 M\xFCnchen", /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("br", {
        className: "jsx-3957130285"
      }), showFullMail ? /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("a", {
        href: "mailto:as@wittendoerfer.de",
        className: "jsx-3957130285",
        children: "as@wittendoerfer.de"
      }) : /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("p", {
        className: "jsx-3957130285",
        children: "as &at& wittendoerfer &dot& de"
      }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
        id: "3957130285",
        children: ["div.jsx-3957130285{margin-top:9rem;}", "@media (min-width:680px){div.jsx-3957130285{-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}}"]
      }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(gradient_block/* GradientBlock */.u, {
        height: "30"
      })]
    }) : null, /*#__PURE__*/(0,jsx_runtime/* jsxs */.BX)("div", {
      className: "jsx-1865803137",
      children: [/*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(trans_link/* TransLink */.H, {
        href: "/",
        className: "no-under",
        children: /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)("img", {
          src: "/_assets/wittendoerfer-logo-sm.svg",
          alt: "Wittendoerfer Logo small",
          width: "96",
          height: "8.5",
          className: "jsx-1865803137"
        })
      }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(primary_nav/* PrimaryNav */.s, {
        data: data.primaryMenu
      }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(style["default"], {
        id: "1865803137",
        children: ["img.jsx-1865803137{width:8rem;height:3rem;}", "div.jsx-1865803137{margin-top:5rem;text-align:right;}", "@media (min-width:780px){div.jsx-1865803137{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}}"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime/* jsx */.tZ)(SecondaryNav, {
      data: data.secondaryMenu
    })]
  });
}

/***/ }),

/***/ 4942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ _cmsMenuFields; },
/* harmony export */   "s": function() { return /* binding */ PrimaryNav; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var _components_trans_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2331);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7997);




var _cmsMenuFields = [{
  name: 'title',
  label: 'Titel',
  widget: 'string'
}, {
  label: 'Link',
  hint: 'z.B. `/verlag`,',
  name: 'href',
  widget: 'string'
}];
function PrimaryNav(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("nav", {
    className: "jsx-3527481330",
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("ul", {
      className: "jsx-3527481330",
      children: data.map(renderLi)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
      id: "3527481330",
      children: ["nav.jsx-3527481330{margin-top:1rem;}", "ul.jsx-3527481330{list-style:none;padding:0;margin-top:0;}"]
    })]
  });

  function renderLi(_ref2) {
    var title = _ref2.title,
        href = _ref2.href;
    var isTopLink = href === '#';
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("li", {
      className: "jsx-1576111501",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_trans_link__WEBPACK_IMPORTED_MODULE_1__/* .TransLink */ .H, {
        href: href,
        className: 'switched' + (isTopLink ? ' toplink' : ''),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
        id: "1576111501",
        children: ["li.jsx-1576111501{font-family:var(--font-sans);font-weight:bold;display:inline-block;margin:0 0 0 1em;}", "a.jsx-1576111501{padding:0.3rem 0;border:none;}", "a.toplink.jsx-1576111501{display:none;}", "@media (min-width:700px){a.toplink.jsx-1576111501{display:block;}}"]
      })]
    }, href);
  }
}

/***/ }),

/***/ 5283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1720);
/* harmony import */ var _components_trans_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2331);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7997);






function Header(_ref) {
  var small = _ref.small;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var hash = window.location.hash;
    window.location.hash = '';
    window.location.hash = hash;
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)("header", {
      className: "jsx-2811202022 " + styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"].dynamic([["973127653", [small ? '1rem' : '4rem']]]) + " " + "logo",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_trans_link__WEBPACK_IMPORTED_MODULE_2__/* .TransLink */ .H, {
        href: "/",
        className: "no-under",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("img", {
          src: "/_assets/wittendoerfer-logo".concat(small ? '-sm' : '', ".svg"),
          alt: "Wittendoerfer Logo",
          width: small ? '110' : '368',
          height: "36",
          className: "jsx-2811202022 " + styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"].dynamic([["973127653", [small ? '1rem' : '4rem']]])
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
        id: "2811202022",
        children: [".logo.jsx-2811202022{max-width:20rem;margin-bottom:1.5rem;padding-bottom:0;}", ".logo.jsx-2811202022 img.jsx-2811202022{max-width:100%;height:auto;}"]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
        id: "973127653",
        dynamic: [small ? '1rem' : '4rem'],
        children: [".logo.__jsx-style-dynamic-selector{margin-top:".concat(small ? '1rem' : '4rem', ";}")]
      })]
    })
  });
}

/***/ }),

/***/ 2331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ TransLink; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7997);


var TransLink = function TransLink(_ref) {
  var children = _ref.children,
      href = _ref.href,
      className = _ref.className;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();

  function onLinkClick(e) {
    if (window.location.href === href || window.location.pathname === href) {
      e.preventDefault();
      return false;
    }

    var isAnchor = href.startsWith('#') || href.startsWith('/#');
    var isHome = window.location.pathname === '/';
    if (isHome && isAnchor) return true;
    e.preventDefault();
    document.body.classList.add('fade-out');
    setTimeout(function () {
      void router.push(href);
    }, 400);
  }

  var prefetch = function prefetch() {
    void router.prefetch(href);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("a", {
    className: className,
    href: href,
    onClick: onLinkClick,
    onMouseEnter: prefetch,
    onPointerEnter: prefetch,
    children: children
  });
};
/*
export function useTransition(href: string) {
  const transition = function () {
    prefetch()

    void router.replace(href, undefined, {
        shallow: true,
      })
router.push(href)
    router.replace(window.location.href + '#l', undefined, {
      shallow: true,
    })
  }

  return { transition, prefetch }
}*/

/***/ }),

/***/ 3092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ AuthorSingleView; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2809);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5988);
/* harmony import */ var next_mdx_remote__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8093);
/* harmony import */ var _components_blocks_gradient_block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6737);
/* harmony import */ var _components_blue_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3735);
/* harmony import */ var _components_footer_footer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3676);
/* harmony import */ var _components_header_header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5283);
/* harmony import */ var _components_trans_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2331);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7997);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_opt_build_repo_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

 // eslint-disable-next-line import/no-internal-modules









var __N_SSG = true;
function AuthorSingleView(props) {
  if (!props || props == {}) return null;
  var _ref = props,
      data = _ref.data,
      source = _ref.source,
      menuData = _ref.menuData;
  var fullName = data.fullName,
      imageSrc = data.imageSrc,
      books = data.books,
      width = data.width,
      height = data.height;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .Fragment */ .HY, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_header_header__WEBPACK_IMPORTED_MODULE_5__/* .Header */ .h, {
      small: true
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("h1", {
      className: "jsx-4137272467",
      children: fullName
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("section", {
      className: "jsx-4137272467" + " " + "serif",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)("div", {
        className: "jsx-4137272467" + " " + "content",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(next_mdx_remote__WEBPACK_IMPORTED_MODULE_8__/* .MDXRemote */ .R, _objectSpread(_objectSpread({}, source), {}, {
          components: {
            GradientBlock: _components_blocks_gradient_block__WEBPACK_IMPORTED_MODULE_2__/* .GradientBlock */ .u
          }
        })), "Bei uns erschienen:", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("ul", {
          className: "jsx-4137272467" + " " + "links",
          children: books ? books.map(function (book) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("li", {
              className: "jsx-4137272467",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_trans_link__WEBPACK_IMPORTED_MODULE_6__/* .TransLink */ .H, {
                href: '/books/' + book.slug,
                children: book.title
              })
            }, book.slug);
          }) : null
        })]
      }), imageSrc ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_blue_image__WEBPACK_IMPORTED_MODULE_3__/* .BlueImage */ .w, {
        imageSrc: imageSrc,
        alt: "Buchcover ".concat(fullName),
        maxWidth: "50",
        width: width,
        height: height
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)("div", {
        className: "jsx-4137272467" + " " + "spacer",
        children: "\xA0"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(styled_jsx_style__WEBPACK_IMPORTED_MODULE_0__["default"], {
      id: "4137272467",
      children: ["@media (min-width:780px){section.jsx-4137272467{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;}section.jsx-4137272467 .content.jsx-4137272467{max-width:47%;}section.jsx-4137272467 .spacer.jsx-4137272467,section.jsx-4137272467 .img-wrapper.jsx-4137272467{width:47%;max-width:47%;margin-top:5rem;}}", ".img-wrapper.jsx-4137272467{background-color:var(--brand);}", ".img-wrapper.jsx-4137272467 img.jsx-4137272467{width:100%;-webkit-filter:grayscale(100%);filter:grayscale(100%);mix-blend-mode:luminosity;opacity:0.7;}"]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_components_footer_footer__WEBPACK_IMPORTED_MODULE_4__/* .Footer */ .$, {
      data: menuData
    })]
  });
}

/***/ }),

/***/ 3472:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/authors/[slug]",
      function () {
        return __webpack_require__(3092);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [871,888,179], function() { return __webpack_exec__(3472); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);